import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { BuilderMenu, VariableTextFeatureFlag } from '@makyoapp/makyo-common'
import { Field } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextEdit } from '@/hooks/useVariableTextEdit'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { VariableTextV2 } from '@/components/VariableTextV2/VariableTextV2'

/**
 * MenuSettingAccordion is a function component that provides an interface for editing menu settings in a builder.
 * It also uses the useBoolean and useState hooks to manage the states of the showIconPicker, showActiveIconPicker, and tempTitle variables.
 */
function MenuSettingAccordion({ menu, menuIdx }: { menu: BuilderMenu; menuIdx: number }) {
  const { updateMenu } = useAppBuilderContext()
  // const [tempTitle, setTempTitle] = useState(menu.title)

  // handle menu title with variable text support
  const [variableMenuTitle, setVariableMenuTitle] = useVariableTextEdit({
    value: menu.title,
    onChange: (value) => {
      updateMenu(menuIdx, (prev) => {
        prev.title = value
      })
    },
  })

  // The menu settings editing interface
  return (
    <AccordionItem itemId='menu-settings' title={<Trans>Menu Settings</Trans>}>
      <Field>
        <label className='w-[80px]'>
          <Trans>Title</Trans>
        </label>
        <div className='w-full pl-3'>
          <VariableTextV2
            id={`menu-${menuIdx}-title`}
            value={variableMenuTitle}
            onChange={setVariableMenuTitle}
            featureFlags={VariableTextFeatureFlag.SingleCell}
            variableColumnOptions={{
              columnTypes: [ColumnTypes.Text],
            }}
          />
        </div>
        {/* <SimpleInput
          value={tempTitle}
          onChange={async (e) => {
            // Update tempTitle when the input changes
            const value = e.currentTarget.value
            setTempTitle(value)
          }}
          onBlur={async () => {
            // Update the menu title when the input loses focus, if the title has changed
            if (menu.title.trim() !== tempTitle.trim()) {
              setTempTitle(tempTitle.trim())
              await updateMenu(menuIdx, (prev) => {
                prev.title = tempTitle.trim()
              })
            }
          }}
        /> */}
      </Field>
    </AccordionItem>
  )
}

export default MenuSettingAccordion
